// extracted by mini-css-extract-plugin
module.exports = {"main":"BreadCrumbs_main__HUd6K","crumb":"BreadCrumbs_crumb__eaNKM","lastCrumb":"BreadCrumbs_lastCrumb__3_EC2","seperator":"BreadCrumbs_seperator__8yjGY"};